<template>
    <div class="fleet-setup-step-summary">
        <div class="summary-left">
            <div class="summary-icon">
                <icon name="faClipboardCheck" type="solid"></icon>
            </div>

            <div>
                <h3>{{ header }}</h3>
                <p>{{ paragraph }}</p>
            </div>
        </div>
        <div class="summary-right">
            <button class="td-btn secondary icon-right" @click="triggerContinue">{{ actionLabel }} <icon name="faArrowRight" type="solid"></icon></button>
        </div>
    </div>
</template>
<script>
import script from './StepSummary';
    export default script;</script>
<style lang="less">
    @import "./StepSummary.less";
</style>
